export default {
  routeExtras: {
    extras: 'Doplňky k trase',
    extraInfo: 'Další informace',
    value: 'Hodnota',
    clickToHighlightOnMap: 'Kliknutím ji zvýrazníte na mapě',
    showAllOnMap: 'Zobrazit vše na mapě'
  }
}
